export const state = {
    bomStockCode:"",
    bomSelectStockCode:""
}

export const mutations = {
    setSelectSockCode(state,StockCode) {
        state.bomSelectStockCode = StockCode 
    } 
}